import { useCallback, useMemo, useState } from 'react';
import { Button, Card } from '@features/ui';
import OtpInput from 'react-otp-input';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  requestResetPasswordAdmin,
  verifyOtp,
} from '@src/services/adminAuth.ts';
import queryString from 'query-string';

export const PasswordResetOtp = () => {
  const [otp, setOtp] = useState('');

  const location = useLocation();
  const navigate = useNavigate();

  const email = useMemo(() => location.state?.email, [location.state?.email]);

  const handleVerifyOtp = useCallback(async () => {
    if (!email) {
      toast.error('Something went wrong. Please try again later.');

      return;
    }
    try {
      const res = await verifyOtp(otp, email);

      const params = {
        token: res.data?.reset_token,
      };
      const searchString = queryString.stringify(params);

      navigate({
        pathname: '/admin/reset-password',
        search: searchString,
      });
    } catch (e) {
      // @ts-ignore
      toast.error(e?.response?.data?.message);
    }
  }, [email, navigate, otp]);

  const handleResendOtp = useCallback(async () => {
    if (!email) {
      toast.error('Something went wrong. Please try again later.');

      return;
    }
    await requestResetPasswordAdmin(email);
  }, [email]);

  return (
    <Card
      className={
        'bg-[#242C36] px-[40px] lg:px-[90px] py-[50px]  w-full lg:w-[584px] items-center'
      }
    >
      <h3 className="text-[27px] mb-17 font-medium">Verify OTP</h3>
      <p className={'text-sm mb-4 font-medium'}>Enter OTP sent to your Email</p>
      {/*@ts-ignore*/}
      <OtpInput
        shouldAutoFocus
        containerStyle={{
          gap: 16,
          justifyContent: 'center',
        }}
        inputStyle={{ width: 44, height: 44 }}
        numInputs={6}
        renderInput={(props) => (
          <input
            {...props}
            className={'border-1 border-[#979797] rounded-[10px] text-center'}
          />
        )}
        value={otp}
        onChange={setOtp}
      />
      <Button
        className="w-full font-bold mb-4 mt-11"
        disabled={otp.length < 6}
        size="lg"
        type="submit"
        variant="gradient"
        onClick={handleVerifyOtp}
      >
        Verify
      </Button>
      <Button
        className={'text-white underline text-sm'}
        variant={'link'}
        onClick={handleResendOtp}
      >
        Resend OTP
      </Button>
    </Card>
  );
};
